import { render } from "./BaseSelectedFilter.vue?vue&type=template&id=72a3b451&scoped=true&ts=true"
import script from "./BaseSelectedFilter.vue?vue&type=script&lang=ts"
export * from "./BaseSelectedFilter.vue?vue&type=script&lang=ts"

import "./BaseSelectedFilter.vue?vue&type=style&index=0&id=72a3b451&scoped=true&lang=css"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a3b451"]])

export default __exports__